function formatNumber(input: number | null | undefined): string {
  if (input === null || typeof input === 'undefined') {
    return '';
  }
  return new Intl.NumberFormat('en-AU').format(input);
}

export default formatNumber;
